jQuery(function($)
{
    // var hide = orion.hide;

    var autoHideSeconds = 10; // also edit animation duration in _feedback.scss for '&.js-feedback-autohide::after'

    var hideTransitionDuration = 1;

    var notificationGap = 10;

    let bottomPosition = 58; // + scroll-to-top-button

    let touchTarget,
        touchStartX,
        touchMoveX,
        touchDistanceX,
        touchSwiped = false,
        touchOffsetPositive = window.innerWidth / 3,
        touchOffsetNegative = (window.innerWidth / 3) * -1;

    const $closeButton = $('.js-feedback-close');

    let $feedbackMessages;

    let $feedbacks;

    function init()
    {
        $feedbacks = getFeedback();

        if ($feedbacks)
        {
            initEvents();

            $feedbacks.each(function()
            {
                showFeedback($(this));
            });

            arrangeFeedbacks($feedbacks);
        }
    }

    function getFeedback()
    {
        $feedbackMessages = $('.js-feedback');

        if ($feedbackMessages.length > 1)
        {
            return $closeButton.add($feedbackMessages);
        }
        else
        {
            $closeButton.removeClass('visible');
            return ($feedbackMessages);
        }
    }

    function initEvents()
    {
        $closeButton.on('click', dismissAll);
        $feedbackMessages.on('click', handleClick);
        $feedbackMessages.on('touchstart', handleTouchStart);
        $feedbackMessages.on('touchmove', handleTouchMove);
        $feedbackMessages.on('touchend', handleTouchEnd);
        $feedbackMessages.on('touchcancel', handleTouchEnd);
    }

    function dismissAll()
    {
        $feedbacks.not($closeButton).each(function()
        {
            hideFeedback($(this));
        });
    }

    function showFeedback($feedback)
    {
        $feedback.addClass('visible');
        var timeoutOne;
        var timeoutTwo;

        if ($feedback.hasClass('js-feedback-autohide'))
        {
            timeoutOne = setTimeout(function()
            {
                hideFeedback($feedback);
            }, autoHideSeconds * 1000);

            timeoutTwo = setTimeout(function()
            {
                $feedback.remove();
            }, (autoHideSeconds * 1000) + (hideTransitionDuration * 1000));
        }

        if ($feedback.hasClass('js-feedback-autohide'))
        {
            $feedback.on('mouseenter touchstart touchmove', function()
            {
                clearTimeout(timeoutOne);
                clearTimeout(timeoutTwo);
            });
        }

        if ($feedback.hasClass('js-feedback-autohide'))
        {
            $feedback.on('mouseleave touchend touchcancel', function()
            {
                timeoutOne = setTimeout(function()
                {
                    hideFeedback($feedback);
                }, autoHideSeconds * 1000);

                timeoutTwo = setTimeout(function()
                {
                    $feedback.remove();
                }, (autoHideSeconds * 1000) + (hideTransitionDuration * 1000));
            });
        }

        if ($feedback.hasClass('js-feedback-autohide'))
        {
            $feedback.on('touchstart touchend', function()
            {
                $feedback.toggleClass('js-feedback-hover');
            });
        }
    }

    function hideFeedback($feedback)
    {
        $feedback.removeClass('visible');

        setTimeout(function()
        {
            $feedback.remove();
            $feedbacks = getFeedback();
            if ($feedbacks)
            {
                arrangeFeedbacks($feedbacks);
            }
        }, 1000);

        if (!$('.js-feedback.visible').length)
        {
            $closeButton.removeClass('visible');
        }
    }

    function getCurrentPosition(element)
    {
        var currentPosition = window.innerHeight - element.position().top - element.outerHeight();

        return currentPosition;
    }

    function arrangeFeedbacks($feedbacks)
    {
        var $newestFeedback = $feedbacks.eq($feedbacks.length - 1);
        var fixedBannerCloseClass = document.querySelector('.fixed-banner__closed');
        var fixedBanner = document.querySelector('.js-fixed-banner');

        if (fixedBanner)
        {
            var fixedBannerHeight = fixedBanner.offsetHeight + bottomPosition;
        }

        if ($feedbacks.length > 0 && getCurrentPosition($feedbacks.eq(0)) != bottomPosition)
        {
            if (fixedBanner && !fixedBannerCloseClass)
            {
                $newestFeedback.css('bottom', fixedBannerHeight + 'px');

                $feedbackMessages.removeClass('feedback-mobile--side-box');
            }
            else
            {
                if (window.innerWidth <= 768) // Mobile
                {
                    if (fixedBanner && fixedBannerCloseClass) // Klasse wird zu stylen gebraucht
                    {
                        $feedbackMessages.addClass('feedback-mobile--side-box');
                    }
                    else
                    {
                        $feedbackMessages.removeClass('feedback-mobile--side-box');
                    }
                    $newestFeedback.css('bottom', 77 + 'px');
                }
                else
                {
                    $newestFeedback.css('bottom', 134 + 'px');
                }
            }
        }

        if ($feedbacks.length > 1)
        {
            if (fixedBanner && !fixedBannerCloseClass)
            {
                $newestFeedback.css('bottom', fixedBannerHeight + 'px');
            }
            else
            {
                if (window.innerWidth <= 768) // Mobile
                {
                    if (fixedBannerCloseClass) // Klasse wird zu stylen gebraucht
                    {
                        $feedbackMessages.addClass('feedback-mobile--side-box');
                    }
                    else
                    {
                        $feedbackMessages.removeClass('feedback-mobile--side-box');
                    }
                    $newestFeedback.css('bottom', 28 + 'px'); // Ohne Scroll-to-top-Button
                }
                else
                {
                    $newestFeedback.css('bottom', 134 + 'px'); // Mit Scroll-to-top-Button
                }
            }


            for (var i = $feedbacks.length - 1; i >= 0; i--)
            {
                if (i < ($feedbacks.length - 1))
                {
                    var $currentNotification = $feedbacks.eq(i);
                    var $previousNotification = $feedbacks.eq(i + 1);

                    var belowNotificationHeight = $previousNotification.outerHeight();
                    var belowNotificationBottom = getCurrentPosition($previousNotification);

                    var newBottom = belowNotificationBottom + belowNotificationHeight + notificationGap;

                    $currentNotification.css('bottom', newBottom + 'px');

                    if (fixedBanner)
                    {
                        if (!fixedBannerCloseClass)
                        {
                            $feedbackMessages.removeClass('feedback-mobile--side-box');
                        }
                    }
                }
            }
        }
    }

    function handleBannerState()
    {
        arrangeFeedbacks($feedbacks);
    }

    document.addEventListener('fixedBannerClosed', handleBannerState);
    document.addEventListener('fixedBannerOpen', handleBannerState);

    function handleClick(e)
    {
        var $target = $(e.target);

        if (!$target.is('a'))
        {
            e.preventDefault();

            hideFeedback($(this));
        }
    }

    function handleTouchStart(e)
    {
        touchTarget = e.target.closest('.js-feedback');
        touchStartX = e.changedTouches[0].screenX;
    }

    function handleTouchMove(e)
    {
        e.preventDefault();

        touchMoveX = e.changedTouches[0].screenX;
        touchDistanceX = touchMoveX - touchStartX;

        touchTarget.style.left = touchDistanceX + 'px';

        if (touchDistanceX > touchOffsetPositive || touchDistanceX < touchOffsetNegative)
        {
            hideFeedback($(this));
            touchSwiped = true;
        }
    }

    function handleTouchEnd()
    {
        if (!touchSwiped)
        {
            touchTarget.style.left = '9px';
        }
        touchSwiped = false;
    }

    init();

    $('body').on(orion.constants.EventFeedbackAdded, init);
});
